export interface ParsedUrn {
  dataset: string;
  collection: string;
  id: string;
}

export function parseUrn(urn: string): ParsedUrn {
  const parts = urn.split('V');
  return {
    dataset:    parts[2]?.split('Z')[1],
    collection: parts[3]?.split('Z')[1],
    id:         parts[4]?.split('Z')[1],
  };
}
